module.exports = __webpack_public_path__ + "static/media/angle-arrow.85cc4f9d.svg";